import React, { Fragment, useEffect, useState } from "react";
import ReactSelect from "react-select";
import Fade from "@material-ui/core/Fade";
import CircularProgress from "@material-ui/core/CircularProgress";
import { ContentTypes } from "../../Constants/selections";
import {
  YOUTUBE_URL,
  IMAGE_UPLOAD,
  VIDEO_UPLOAD,
  GIF_UPLOAD,
} from "../../Constants/types";
import { UPLOADING_VIDEO, UPLOADING_IMAGE } from "../../Constants/string";
import ImageUpload from "../ContentUpload/ImageUpload";
import VideoUpload from "../ContentUpload/VideoUpload";
import YoutubeInput from "../ContentUpload/YoutubeInput";
import MenuList from "../ContentUpload/MenuList";
import SingleValue from "../ContentUpload/SingleValue";
import Firebase from "../../firebasehelper";

const MediaSelect = (props) => {
  const { uploadFolder, existingContent, onChangeContent } = props;
  const [loadingState, setLoadingState] = useState("");
  const [mediaType, setMediaType] = useState("");
  const [mediaUrl, setMediaUrl] = useState("");
  const [modification, setModification] = useState({});

  useEffect(() => {
    onChangeContent(mediaType, mediaUrl);
  }, [mediaType, mediaUrl]);

  useEffect(() => {
    if (existingContent) {
      setMediaType(existingContent.mediaType);
      setMediaUrl(existingContent.mediaUrl);
    }
  }, [existingContent]);

  const handleSelectContentType = (value) => {
    // const newContent = _.cloneDeep(content);
    // newContent["media_type"] = value.value;
    // setContent(newContent);
    setMediaType(value.value);
    setMediaUrl("");
    // modification tracking..
    let newModification = { ...modification, media_type: value.value };
    setModification(newModification);
  };

  const handleSetMediaURL = (imgURL) => {
    // const newContent = _.cloneDeep(content);
    // newContent["media_url"] = imgURL;
    // setContent(newContent);
    setMediaUrl(imgURL);
    // modification tracking..
    let newModification = { ...modification, media_url: imgURL };
    setModification(newModification);
  };

  const uploadContent = (contentType) => async (mediaContent) => {
    const title = new Date().getTime().toString();
    if (contentType === GIF_UPLOAD) {
      setLoadingState({ loading: true, loading_script: UPLOADING_IMAGE });
      let gif_url = await Firebase.uploadGif(
        mediaContent,
        title,
        uploadFolder + "/gifs"
      );
      setLoadingState({ loading: false, loading_script: "" });
      handleSetMediaURL(gif_url);
    } else if (contentType === IMAGE_UPLOAD) {
      setLoadingState({ loading: true, loading_script: UPLOADING_IMAGE });
      let img_url = await Firebase.uploadImage(
        mediaContent,
        title,
        uploadFolder + "/images"
      );
      setLoadingState({ loading: false, loading_script: "" });
      handleSetMediaURL(img_url);
    } else if (contentType === VIDEO_UPLOAD) {
      const uploadTask = Firebase.uploadVideo(
        mediaContent,
        uploadFolder + "/videos"
      );
      setLoadingState({ loading: true, loading_script: UPLOADING_VIDEO });
      uploadTask.on(
        "state_changed",
        handleUploadProgress,
        handleUploadError,
        () => {
          uploadTask.snapshot.ref.getDownloadURL().then((downloadURL) => {
            setLoadingState({ loading: false, loading_script: "" });
            handleSetMediaURL(downloadURL);
          });
        }
      );
    } else if (contentType === YOUTUBE_URL) {
      handleSetMediaURL(mediaContent);
    }
  };

  const handleUploadProgress = (snapshot) => {
    var progress = (
      (snapshot.bytesTransferred / snapshot.totalBytes) *
      100
    ).toFixed(0);
    const loading_script = UPLOADING_VIDEO + " " + progress + "%";
    setLoadingState({ loading: loadingState.loading, loading_script });
  };

  const handleUploadError = (error) => {
    setLoadingState({ loading: false, loading_script: "" });
  };

  return (
    <Fragment>
      <div className="form-group row">
        <div className="col-12">
          <ReactSelect
            value={mediaType ? { label: mediaType, value: mediaType } : null}
            onChange={handleSelectContentType}
            options={ContentTypes}
            placeholder="What content would you like to post?"
            isSearchable={false}
            components={{ MenuList, SingleValue }}
          ></ReactSelect>
        </div>
      </div>
      {mediaType && (
        <div className="col-div mb-2">
          {mediaType === YOUTUBE_URL && (
            <YoutubeInput
              onChangeContent={uploadContent(YOUTUBE_URL)}
              currentUrl={mediaUrl !== "" ? mediaUrl : null}
            />
          )}
          {mediaType === IMAGE_UPLOAD && (
            <ImageUpload
              onChangeContent={uploadContent(IMAGE_UPLOAD)}
              contentUrl={mediaUrl !== "" ? mediaUrl : null}
            />
          )}
          {mediaType === GIF_UPLOAD && (
            <ImageUpload
              isGif={true}
              onChangeContent={uploadContent(GIF_UPLOAD)}
              contentUrl={mediaUrl !== "" ? mediaUrl : null}
            />
          )}
          {mediaType === VIDEO_UPLOAD && (
            <VideoUpload
              onChangeContent={uploadContent(VIDEO_UPLOAD)}
              defaultVideo={mediaUrl !== "" ? mediaUrl : null}
            />
          )}
        </div>
      )}
      <Fade
        in={loadingState.loading}
        style={{
          transitionDelay: loadingState.loading ? "800ms" : "0ms",
        }}
        unmountOnExit
      >
        <Fragment>
          <p>{loadingState.loading_script}</p>
          <CircularProgress />
        </Fragment>
      </Fade>
    </Fragment>
  );
};

export default MediaSelect;



// WEBPACK FOOTER //
// ./src/components/MediaSelect/index.js